export enum MainProgressBarEnum {
    Search = 1,
    DeliveryOptions = 2,
    RecommendedServices = 3,
    Booking = 4,
    Verification = 5,
    OrderConfirmation = 6
}